import { render } from "./VoucherVouchers.vue?vue&type=template&id=4b36669a&scoped=true"
import script from "./VoucherVouchers.vue?vue&type=script&lang=js"
export * from "./VoucherVouchers.vue?vue&type=script&lang=js"

import "./VoucherVouchers.vue?vue&type=style&index=0&id=4b36669a&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b36669a"]])

export default __exports__